<style lang="stylus" scoped>
@import './cardMap.stylus';

span, .font20 {
  cursor: pointer;
}

.font20:hover {
  color: #00a28a;
}

.mark {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  background: rgba(0, 0, 0, 0.7);
  z-index: 100;

  .circle {
    margin: auto;
  }
}
</style>

<template>
  <div class="home-main">
    <div class="mark" v-if="mark">
      <el-progress type="circle" :percentage="progressNum" class="circle" style="color:#fff;"></el-progress>
    </div>
    <div class="map-search radius-5">
      <div class="map-title">
        <el-row>
          <CardHeader/>
          <el-col :span="12">
            <div class="t-r">
              <el-date-picker
                :clearable="false"
                v-model="timeSection"
                value-format="timestamp"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              ></el-date-picker>
              <el-button v-show="hideExport" style="margin-left:20px;" @click="exportData">导出</el-button>
              <SearchBtn/>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="font12 p-2 b1">
        <span class="color2 pointer" v-if="userType" @click="goBack">全国></span>
        <span class="color2 pointer" v-else>全国></span>
        <span>{{provinceName}}</span>
      </div>
    </div>
    <TotalCard :totalCount="totalCount"/>
    <Card v-for="(item,index) in cityItem" :key="index" :item="item" :toDot="toDot"/>
  </div>
</template>

<script>
import SearchBtn from '@/components/searchBtn'
import CardHeader from './components/cardHeader'
import Card from './components/card'
import TotalCard from './components/totalCard.vue'

import http from '@/api/cardData'
import Cookies from 'js-cookie'
import { hideExport } from '@/utils/tools'
export default {
  name: 'home',
  components: {
    CardHeader,
    SearchBtn,
    Card,
    TotalCard
  },
  data() {
    return {
      hideExport:hideExport,
      timeSection: [
        new Date(new Date() * 1 - 30 * 24 * 3600 * 1000) * 1,
        new Date(new Date() * 1 - 0 * 24 * 3600 * 1000) * 1
      ],
      provinceCode: null,
      provinceName: null,
      totalCount: {},
      cityItem: [],
      searchItem: [],
      mark: false, //遮罩层
      progressNum: 0
    }
  },
  computed: {
    userType() {
      return this.$store.getters.userType != 2
    },
    allTab() {
      return this.$store.state.app.tab
    }
  },
  created() {
    let timeSection = this.$route.query.timeSection
    let provinceCode = this.$route.query.provinceCode
    let provinceName = this.$route.query.provinceName
    this.timeSection = timeSection
      ? JSON.parse(timeSection)
      : [new Date(new Date() * 1 - 30 * 24 * 3600 * 1000) * 1, new Date() * 1]
    this.provinceName = provinceName ? decodeURIComponent(provinceName) : null
    this.provinceCode = provinceCode ? decodeURIComponent(provinceCode) : null
    this.initData()
  },
  watch: {
    timeSection: function(value, oldValue) {
      this.initData()
    },
    '$store.state.app.tab': function(value, oldValue) {
      this.initData()
    }
  },
  methods: {
    exportData() {
      let that = this
      that.mark = true
      let reqId = Cookies.get('user')
      let times
      times = setInterval(function() {
        http[that.allTab].progress({ reqId }).then(e => {
          that.progressNum = e.data.percent
          if (e.data.percent >= 100) {
            that.mark = false
            that.progressNum = 0
            clearInterval(times)
          }
        })
      }, 100)
      reqId += new Date() * 1
      window.location.assign(
        http[that.allTab].exportDataCity({
          start: that.timeSection[0],
          end: that.timeSection[1],
          provinceCode: that.provinceCode,
          reqId
        })
      )
    },
    initData() {
      let that = this
      let _option = {
        timeSection: [
          this.timeSection[0] * 1 + '',
          this.timeSection[1] * 1 + ''
        ],
        provinceCode: this.provinceCode
      }
      http[that.allTab].cityDate(_option).then(function(e) {
        let data = e.data
        that.totalCount = data.totalCount
        that.cityItem = data.cityItem
      })
    },
    goBack() {
      history.back()
    },
    toDot(item) {
      this.$router.push({
        name: 'cardDot',
        query: {
          cityCode: item.cityCode,
          cityName: item.cityName,
          countItem: JSON.stringify(item.countItem),
          provinceName: this.provinceName
        }
      })
    }
  }
}
</script>
